import { render, staticRenderFns } from "./brandCount.vue?vue&type=template&id=627bb60d"
import script from "./brandCount.vue?vue&type=script&lang=js"
export * from "./brandCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports